import * as React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import compose from 'recompose/compose';
import { withRouter } from 'react-router-dom';
import { closeModal } from 'src/actions/modals';

import { withCurrentUser } from 'src/components/withCurrentUser';
import ModalContainer from '../modalContainer';
import { PrimaryButton } from 'src/components/button';
import { modalStyles } from '../styles';
import { TextArea } from '../../formElements';
import { addToastWithTimeout } from 'src/actions/toasts';
import EmojiPicker from 'src/components/emojiPicker';
import Icon from 'src/components/icon';

import commitReport from 'shared/graphql/mutations/report/commitReport';
import { Form, Actions } from './style';

const DATA_TEST_PRE = 'components-modals-ReportModal-';
class ReportModal extends React.Component {
  constructor(props) {
    super();
    this.state = {
      comment: '',
      createError: false,
      loading: false,
      showEmojiPicker: false,
    };
  }

  close = () => {
    this.props.dispatch(closeModal());
  };

  edit = async e => {
    e.preventDefault();
    this.setState({ loading: true });

    const {
      dispatch,
      commitReport,
      relativeId,
      type,
      link,
      emailContent,
    } = this.props;
    const { comment } = this.state;
    let body = comment;
    // if (this.state.mediaFile) {
    //   const mediaFile = this.state.mediaFile;
    //   const fileUrl = await getPresignedPutUrl({
    //     location: 'post',
    //     file: mediaFile,
    //   });
    //   const uploading = `![${mediaFile.name}](${fileUrl})`;
    //   if (mediaFile.type === 'video/mp4') {
    //     body = comment + ' ' + fileUrl;
    //   } else {
    //     body = comment + uploading;
    //   }
    // }
    const content = {
      body,
    };
    emailContent.reason = comment;
    const input = {
      type,
      relativeId,
      content,
      link,
      emailContent,
    };
    commitReport(input)
      .then(({ data: { commitReport } }) => {
        if (commitReport && commitReport !== null) {
          this.setState({ loading: false });
          this.props.dispatch(closeModal());
          return dispatch(addToastWithTimeout('success', 'Report Send!'));
        } else {
          return dispatch(
            addToastWithTimeout(
              'error',
              "We weren't able to save these changes. Try again?"
            )
          );
        }
      })
      .catch(err => {
        dispatch(addToastWithTimeout('error', err.message));
      });
  };

  closePicker = () => {
    this.setState({ showEmojiPicker: false });
  };
  onSelectEmoji = ({ native }) => {
    this.closePicker();
  };
  showPicker = () => {
    this.setState({ showEmojiPicker: true });
  };

  // previewMedia = blob => {
  //   const reader = new FileReader();
  //   reader.onload = () => {
  //     this.setState({
  //       mediaPreview: reader.result.toString(),
  //       // isSendingMediaMessage: false,
  //       mediaFile: blob,
  //     });
  //   };
  //   if (blob) {
  //     reader.readAsDataURL(blob);
  //   }
  // };

  changeComment = e => {
    const comment = e.target.value;
    this.setState({
      comment,
    });
  };

  renderModalContent() {
    const { comment, loading } = this.state;
    return (
      <ModalContainer title="Report" closeModal={this.close}>
        <Form>
          <TextArea
            testId={`${DATA_TEST_PRE}TextArea`}
            id="comment"
            placeholder="Why would you like to report?"
            defaultValue={comment}
            onChange={this.changeComment}
            showEmojiPicker={this.showPicker}
          />
          <Actions>
            <PrimaryButton
              data-testid={`${DATA_TEST_PRE}${
                loading ? 'Committing' : 'Report'
              }`}
              isLoading={loading}
              onClick={this.edit}
            >
              {loading ? 'Committing...' : 'Report'}
            </PrimaryButton>
          </Actions>

          {this.state.showEmojiPicker ? (
            <EmojiPicker
              onSelectEmoji={this.onSelectEmoji}
              closePicker={this.closePicker}
            />
          ) : null}
        </Form>
      </ModalContainer>
    );
  }
  render() {
    const { isOpen } = this.props;
    const styles = modalStyles(620);

    return (
      <Modal
        /* TODO(@mxstbr): Fix this */
        ariaHideApp={false}
        isOpen={isOpen}
        onRequestClose={this.close}
        shouldCloseOnOverlayClick={true}
        style={styles}
        closeTimeoutMS={330}
      >
        {this.renderModalContent()}
      </Modal>
    );
  }
}

const map = state => ({
  isOpen: state.modals.isOpen,
});
export default compose(
  // $FlowIssue
  connect(map),
  commitReport,
  withCurrentUser,
  withRouter
)(ReportModal);
